import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { List, Checkbox, Tab, Card, Icon } from 'semantic-ui-react';

import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import TargetLink from '../target-link';

const helpUrl = 'https://help.dyzio.co/en/articles/5137000-adding-business-units-or-brands';

const helpLinkStyle = {
  color: 'rgb(32, 196, 158)',
};


const columns = [
  'facebook',
  'instagram',
  'twitter',
  'youtube',
  'website',
  'snapchat',
  'telegram',
  'twitch',
  'tiktok',
  'linkedin',
  'Instagram Engagement Rate',
];
const OPTIONAL_COLUMN_COUNT = _.keys(columns).length;

const InfluencerTableSettings = props => {
  const { columnsSettings,
    businessUnits,
    selectedBusinessUnits,
    onColumnCheckboxChange,
    onBusinessUnitsChange,
    tab,
  } = props;

  const ColumnsChooser = () => (
    <List size="mini">
      <Card fluid>
        <Card.Content>
          <p>
            Add or remove the columns that appear in the influencer database table.
          </p>
        </Card.Content>
      </Card>
      {
        _.map(columns, column => (
          <List.Item>
            <Checkbox
              checked={_.get(columnsSettings, `columns.${_.snakeCase(_.lowerCase(column))}.displayed`, true)}
              label={column}
              onChange={onColumnCheckboxChange}
            />
          </List.Item>
        ))
      }
    </List>
  );

  const BusinessUnitsFilter = () => (
    <List size="mini">
      <Card fluid>
        <Card.Content>
          <p>
          Add or remove the Business Units or Brands that you want to filter your My Influencers database by.
          </p>
        </Card.Content>
        <Card.Content extra>
          <TargetLink style={helpLinkStyle} href={helpUrl} renderIf>
            <Icon name="help" circular />
              click here for help
          </TargetLink>
        </Card.Content>
      </Card>
      {
        _.map(businessUnits, businessUnit => (
          <List.Item>
            <Checkbox
              checked={_.get(selectedBusinessUnits,
                `businessUnits.${_.snakeCase(_.lowerCase(businessUnit.text))}.selected`, false)}
              label={businessUnit.text}
              id={businessUnit.key}
              onChange={onBusinessUnitsChange}
            />
          </List.Item>
        ))
      }
    </List>
  );

  const panes = [
    { menuItem: 'Columns', render: () => <Tab.Pane><ColumnsChooser /></Tab.Pane> },
    { menuItem: 'Filter Business Units & Brands', render: () => <Tab.Pane><BusinessUnitsFilter /></Tab.Pane> },
  ];

  const Tabs = () => <Tab panes={panes} defaultActiveIndex={tab || 0} />;

  return (
    <DyzioModal
      hasActionButton
      size="tiny"
      actionButtonContent="Save Settings"
      headerText="Settings"
      onActionButtonClick={props.onClose}
      {...props}
    >
      <Tabs />
    </DyzioModal>
  );
};


InfluencerTableSettings.propTypes = {
  onColumnCheckboxChange: PropTypes.func.isRequired,
  onBusinessUnitsChange: PropTypes.func.isRequired,
  columnsSettings: PropTypes.object.isRequired,
  selectedBusinessUnits: PropTypes.object.isRequired,
  businessUnits: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  tab: PropTypes.object.isRequired,
};

export default InfluencerTableSettings;
export { OPTIONAL_COLUMN_COUNT };



/** WEBPACK FOOTER **
 ** ./src/components/influencer-table-settings/index.js
 **/